import React from 'react';
import { Alert } from '@mui/material';
import styled from 'styled-components';

type ValidationPopupProps = {
  message: string;
  onClose: () => void;
};

const ErrorAlert = styled(Alert)`
  background-color: #ffeceb;
  border: 1px solid #d93630;
  color: #d93630;
`;

export const ValidationPopup = ({ message, onClose }: ValidationPopupProps) => {
  if (!message) return null;
  return (
    <div style={{ position: 'fixed', width: '604px', bottom: '140px' }}>
      <ErrorAlert severity="error" onClose={onClose} icon={null}>
        {message}
      </ErrorAlert>
    </div>
  );
};
